import { useMutation } from 'react-query';
import NotificationsAPI from 'services/API/NotificationsAPI';

export const useShareCollection = () => {
  const shareCollection = useMutation(
    ({ collectionId, email }: { collectionId: Number; email: string }) =>
      NotificationsAPI.postShareCollection(collectionId as number, email),
  );

  return {
    shareCollection,
  };
};
